// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2hXJv","header":"ReportDetails_header__17Tsb","title":"ReportDetails_title__1HXNC","left":"ReportDetails_left__3g5ix"};